module.exports = __webpack_public_path__ + "static/media/City.d35422a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/City.svg
// module id = 326
// module chunks = 1